import React from "react";
import { droitsDuProfil } from "./comptesOperateur";

// ============================================================
// Encadré « Ce que ce profil peut faire chez … » (maquette 10) : les droits
// que donnent les régimes de la structure, puis ce qu'ajoute le rôle. Il suit
// le rôle coché, dans la modale de création comme sur la fiche d'un compte :
// c'est ce qui aide la Caf et l'administrateur à choisir le bon rôle.
// ============================================================

const DroitsProfil = ({ regimes = [], role, nomStructure }) => {
  const droits = droitsDuProfil({ regimes, role });
  if (!droits.length) return null;
  return (
    <aside className="droits-profil" aria-live="polite">
      <h3>Ce que ce profil peut faire chez {nomStructure}</h3>
      <dl>
        {droits.map((d) => (
          <div key={d.titre}>
            <dt>{d.titre}</dt>
            <dd>{d.texte}</dd>
          </div>
        ))}
      </dl>
    </aside>
  );
};

export default DroitsProfil;
